import request from '@/utils/request'

/**
 * 获取字典数据
 * @param dictType  字典类型
 * @returns {AxiosPromise}
 */
export function getDict(dictType) {
    return request({
        url: `/api/dict?dict_type=${dictType}`,
        method: 'get'
    })
}
